import { DEFAULT_CONTAINER_WIDTH, DEFAULT_BREAKPOINTS, DEFAULT_SPACING, } from './constants';
export var getBreakpointForScreenWidth = function (breakpoints, screenWidth) {
    return breakpoints
        .slice()
        .reverse()
        .find(function (point) { return screenWidth >= point.maxWidth; }) || breakpoints[0];
};
export var getGridConfiguration = function (_a) {
    var _b = _a.breakpoints, breakpoints = _b === void 0 ? DEFAULT_BREAKPOINTS : _b, _c = _a.containerWidth, containerWidth = _c === void 0 ? DEFAULT_CONTAINER_WIDTH : _c, _d = _a.screenWidth, screenWidth = _d === void 0 ? DEFAULT_CONTAINER_WIDTH : _d, _e = _a.elementSpacing, elementSpacing = _e === void 0 ? DEFAULT_SPACING : _e, _f = _a.dontScale, dontScale = _f === void 0 ? false : _f;
    var _g = getBreakpointForScreenWidth(breakpoints, screenWidth), elementWidth = _g.elementWidth, elementHeight = _g.elementHeight, elementsPerRowConfig = _g.elementsPerRow;
    // We try to place X elements per row such that width of elements is as close
    // to targetWidth as possible, but not greater
    var elementsPerRow = elementsPerRowConfig !== null && elementsPerRowConfig !== void 0 ? elementsPerRowConfig : Math.max(1, Math.floor((containerWidth + elementSpacing) / (elementWidth + elementSpacing)));
    if (dontScale) {
        return {
            elementWidth: elementWidth,
            elementHeight: elementHeight,
            elementSpacing: elementSpacing,
            elementsPerRow: elementsPerRow,
        };
    }
    var ratio = elementHeight ? elementWidth / elementHeight : 0;
    var adjustedElementWidth = (containerWidth + elementSpacing) / elementsPerRow - elementSpacing;
    var adjustedElementHeight = adjustedElementWidth / ratio;
    return {
        elementWidth: adjustedElementWidth,
        elementHeight: adjustedElementHeight,
        elementSpacing: elementSpacing,
        elementsPerRow: elementsPerRow,
    };
};
//# sourceMappingURL=helpers.js.map